import { useEffect, useState } from 'react';

//components
import { Card } from 'primereact/card';

//api
import { PromptService } from "../../../service/prompt-service";

        

const PromptCard = ()=>{
    const [prompts,setPrompts]= useState(0)

    useEffect(()=>{
        const fetchProjects = ()=>{
            PromptService.getAllPrompts(
                (data)=>{
                    setPrompts(data.count)
                },
                (error) => {
                    console.error("Errore durante il recupero dei prompt: ", error);
                    
                }
            )
        }
        fetchProjects()
    },[])

    return (
        <div>
            <Card title="Prompt" className='dashboard__PromptWrapper'>
                <div className='dashboard__CardContent'>
                    <div>
                     {prompts}
                    </div>
                    <div>
                       <i className='pi pi-align-left'></i> 
                    </div>
                </div>
                <div className='dashboard__Link'>
                    <a href='/dashboard/prompt'>Vai ai prompt <i className='pi pi-arrow-right' ></i></a>
                </div>
            </Card>
        </div>
    )
}

export default PromptCard